import {
  HiBeaker,
  HiCamera,
  HiPhotograph,
  HiMicrophone,
  HiEmojiHappy,
} from "react-icons/hi";

// Constants
export const MESSAGES_PER_PAGE = 20;

export const quickEmojiOptions = ["❤️", "😂", "👍", "🔥", "🎉"];

export const buttonOptions = [
  { icon: HiBeaker, name: "Beaker" },
  { icon: HiCamera, name: "Camera" },
  { icon: HiPhotograph, name: "Image" },
  { icon: HiMicrophone, name: "Microphone" },
  { icon: HiEmojiHappy, name: "Smile" },
];

// animatedUsers array'ini component dışına taşıdık.
export const animatedUsers = [
  {
    id: 1,
    name: "Sila Koç",
    avatar: "https://randomuser.me/api/portraits/women/44.jpg",
    messages: [
      "Merhaba! Bu mekanı çok sevdim 👋",
      "Kahveleri harika! ☕️",
      "Arkadaş canlısı bir ortamı var",
      "Kesinlikle tekrar geleceğim 😊",
      "Herkese tavsiye ederim!",
    ],
  },
  {
    id: 2,
    name: "Ahmet Yılmaz",
    avatar: "https://randomuser.me/api/portraits/men/85.jpg",
    messages: [
      "Burası gerçekten çok güzel!",
      "Çalışanlar çok ilgili 🌟",
      "Ambiyans muhteşem",
      "En sevdiğim mekan oldu 💫",
      "Arkadaşlarıma da önereceğim",
    ],
  },
];
